
export function AboutSection() {
  return (
    <section id="about" className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          {/* Content */}
          <div>
            <h3 className="text-4xl font-bold text-gray-900 mb-6">
              자연과 과학의 완벽한 조화
            </h3>
            <div className="space-y-6 text-gray-600 leading-relaxed">
              <p>
                라코스벨은 2019년 3월 13일 설립 이래, 천연식물에서 얻어지는 귀한 약초들의 순수한 에센셜의 성분과 
                아로마 테라피의 전문인력들의 연구·개발을 바탕으로 제조를 하고 있습니다.
              </p>
              <p>
                천연 약초를 이용한 아로마 에센스 및 이의 제조방법에 관한 원천 기술특허를 바탕으로 하는 연구진들과 협력하여 
                자연이 선사하는 순수한 에너지를 과학적으로 구현합니다.
              </p>
              <p>
                그 결과, 피부와 우리 몸에 꼭 필요한 식물의 파이토케미컬 영양과 편안한 향기를 전달하는 
                프리미엄 스킨케어 솔루션을 선보이고 있습니다.
              </p>
            </div>
            
            {/* Features */}
            <div className="mt-8 grid grid-cols-1 sm:grid-cols-3 gap-6">
              <div className="text-center">
                <div className="w-16 h-16 bg-emerald-100 rounded-full flex items-center justify-center mx-auto mb-3">
                  <i className="ri-leaf-line text-2xl text-emerald-600"></i>
                </div>
                <h4 className="font-semibold text-gray-900 mb-1">100% 자연 유래</h4>
                <p className="text-sm text-gray-600">에센셜 오일 사용</p>
              </div>
              <div className="text-center">
                <div className="w-16 h-16 bg-emerald-100 rounded-full flex items-center justify-center mx-auto mb-3">
                  <i className="ri-flask-line text-2xl text-emerald-600"></i>
                </div>
                <h4 className="font-semibold text-gray-900 mb-1">무첨가</h4>
                <p className="text-sm text-gray-600">인공 향료, 색소, 화학원료</p>
              </div>
              <div className="text-center">
                <div className="w-16 h-16 bg-emerald-100 rounded-full flex items-center justify-center mx-auto mb-3">
                  <i className="ri-recycle-line text-2xl text-emerald-600"></i>
                </div>
                <h4 className="font-semibold text-gray-900 mb-1">친환경</h4>
                <p className="text-sm text-gray-600">지속 가능한 가치 추구</p>
              </div>
            </div>
          </div>

          {/* Image */}
          <div className="relative">
            <img
              src="https://public.readdy.ai/ai/img_res/e0730bac6aec53986a577e74bccca696.jpg"
              alt="라코스벨 연구소"
              className="w-full h-[500px] object-cover rounded-2xl shadow-2xl"
            />
            <div className="absolute -bottom-6 -left-6 bg-white p-6 rounded-xl shadow-lg">
              <div className="flex items-center space-x-4">
                <div className="w-12 h-12 bg-emerald-600 rounded-full flex items-center justify-center">
                  <i className="ri-award-line text-xl text-white"></i>
                </div>
                <div>
                  <p className="font-semibold text-gray-900">30여년 연구개발</p>
                  <p className="text-sm text-gray-600">천연 토종약초 에센셜</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
